<template>
  <ChartNormal
    size="12"
    offset="0"
    title="Recycled"
    chart="column"
    chartType="recycled"
    :isCity="false"
    :withDate="true"
    :withFinancial="false"
    :recycled="true"
  />
</template>

<script>
import ChartNormal from "../../../components/chart/chartNormal";
export default {
  name: "Recycled",
  components: {
    ChartNormal
  }
};
</script>
